import React, { useMemo } from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { useGetAccountFieldHistory } from '~/hooks/apis/contracting/useGetAccountFieldHistory';
import { useGetAccount } from '~/hooks/apis/offers/useGetAccount';

import FieldHistoryPanel from '../shared/fieldHistory/FieldHistoryPanel';
import { newestOfCountLabel } from '../shared/fieldHistory/newestOfCountLabel';
import { toFieldHistoryEntries } from '../shared/fieldHistory/toFieldHistoryEntries';

import AccountTabs from './AccountTabs';

const ACCOUNT_HISTORY_PAGE_SIZE = 100;

export default function AccountHistoryPage() {
  const { id_account: accountId } = useParams<{ id_account: string }>();
  const { data: account } = useGetAccount(accountId);
  const {
    data: history,
    error,
    isLoading,
  } = useGetAccountFieldHistory(accountId, { limit: ACCOUNT_HISTORY_PAGE_SIZE });
  const entries = useMemo(() => toFieldHistoryEntries(history?.result ?? []), [history]);
  const totalCount = history?.pagination.total_items ?? 0;
  const chipLabel = newestOfCountLabel('change', entries.length, totalCount);

  return (
    <>
      <Helmet>
        <title>Account History | {account?.name || accountId}</title>
      </Helmet>

      <AccountTabs accountId={accountId} activeTab="history" />
      <FieldHistoryPanel
        chipLabel={history ? chipLabel : undefined}
        entries={entries}
        error={error}
        isLoading={isLoading}
        title="Account History"
        totalCount={totalCount}
      />
    </>
  );
}
